export default __webpack_public_path__ + "static/media/black-icon.3613f7c9.png";